import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../ui/select';
import { Megaphone } from 'lucide-react';
import TeslaTicketsPanel from './TeslaTicketsPanel';
import CashbackWeekendPanel from './CashbackWeekendPanel';
import VipReleasePanel from './VipReleasePanel';
import WednesdayFreespinsPanel from './WednesdayFreespinsPanel';
import SecondChanceFreespinsPanel from './SecondChanceFreespinsPanel';
import FridayLoyaltyPanel from './FridayLoyaltyPanel';
import TestFreespinsPanel from './TestFreespinsPanel';

// The recurring CRM campaigns whose values are entered by hand. `value` is the stable key the
// backend stores against; `label` is what CRM sees. `Panel` is the campaign's editor — campaigns
// without one yet show a placeholder.
const CAMPAIGNS = [
  { value: 'friday_loyalty_bonus',    label: 'Friday Loyalty Bonus', Panel: FridayLoyaltyPanel },
  { value: 'wednesday_freespins',     label: 'Wednesday Freespins', Panel: WednesdayFreespinsPanel },
  { value: 'second_chance_freespins', label: 'Second Chance Freespins', Panel: SecondChanceFreespinsPanel },
  { value: 'vip_release',             label: 'VIP Release', Panel: VipReleasePanel },
  { value: 'live_casino_cashback_25', label: '25% Live Casino Cashback', Panel: CashbackWeekendPanel },
  { value: 'tesla_tickets',           label: 'Tesla Tickets', Panel: TeslaTicketsPanel },
  { value: 'issue_test_freespins',    label: 'Issue Test Freespins', Panel: TestFreespinsPanel },
];

const CrmCampaignsPage = () => {
  const [campaign, setCampaign] = useState('');
  const selected = CAMPAIGNS.find((c) => c.value === campaign);

  return (
    <div className="max-w-6xl mx-auto py-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-ink">CRM Campaigns</h2>
        <p className="text-sm text-ink-dim mt-1 font-medium">
          Enter the manual values for a CRM campaign.
        </p>
      </div>

      <div className="mb-6 flex items-center gap-1.5">
        <span className="font-mono text-[10px] uppercase tracking-wider text-ink-mute">Campaign</span>
        <Select value={campaign} onValueChange={setCampaign}>
          <SelectTrigger className="h-9 w-64 text-sm">
            <SelectValue placeholder="Select a campaign" />
          </SelectTrigger>
          <SelectContent>
            {CAMPAIGNS.map((c) => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {selected?.Panel ? (
        <selected.Panel />
      ) : (
        <Card>
          <CardContent className="py-10 flex flex-col items-center gap-2 text-center">
            <Megaphone className="h-6 w-6 text-ink-mute" />
            <p className="text-sm font-medium text-ink-dim">
              {selected ? `${selected.label} is not set up yet.` : 'Pick a campaign above to enter its values.'}
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default CrmCampaignsPage;
